export enum InvoiceViewState {
  Draft,
  DraftNotSent,
  Overdue,
}

export enum InvoiceViewPaymentState {
  Unpaid,
  PartiallyPaid,
  Paid,
}

export enum RotRutState {
  Disable,
  Enable,
}

export enum InvoiceViewChartState {
  Draft,
  Unpaid,
  OverDue,
  ReminderSent,
  Collection,
  Paid,
}

export enum CreditInvoiceSendType {
  CreditFullSendNew = 0,
  CreditFull = 1,
  Edit = 3,
}

export enum InvoiceProductTabs {
  Amount,
  Text,
  Periodisation,
  Dimensions,
  EUVatCategory,
}
